// extracted by mini-css-extract-plugin
export default {"envBalloon":"_1g_3yL1Hs8tQ8GR-QYnO3m","local":"_3kv22WExNJnyxgW5UCuKpp","test":"pN8tfWKc45qOWggGe0bMG","stg":"aHjmND_eZieQJLCLezf1d"};